import {
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaTelegramPlane,
    FaTiktok,
    FaWhatsapp,
    FaYoutube,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const PLATFORMS = [
    { key: 'facebook', Icon: FaFacebookF, label: 'Facebook', defaultUrl: 'https://facebook.com' },
    { key: 'instagram', Icon: FaInstagram, label: 'Instagram', defaultUrl: 'https://instagram.com' },
    { key: 'x', Icon: FaXTwitter, label: 'X', defaultUrl: 'https://twitter.com' },
    { key: 'linkedin', Icon: FaLinkedinIn, label: 'LinkedIn', defaultUrl: 'https://linkedin.com' },
    { key: 'youtube', Icon: FaYoutube, label: 'YouTube', defaultUrl: 'https://youtube.com' },
    { key: 'tiktok', Icon: FaTiktok, label: 'TikTok', defaultUrl: 'https://tiktok.com' },
    { key: 'telegram', Icon: FaTelegramPlane, label: 'Telegram', defaultUrl: 'https://t.me' },
    { key: 'whatsapp', Icon: FaWhatsapp, label: 'WhatsApp', defaultUrl: 'https://wa.me' },
];

function normalizeUrl(url) {
    const raw = String(url || '').trim();
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.startsWith('wa.me/') || raw.startsWith('t.me/')) return `https://${raw}`;
    return `https://${raw}`;
}

export function getConfiguredSocialLinks(socialLinks = {}) {
    // Ensure all platforms stay visible even if the merchant has not configured URLs yet.
    const links = socialLinks && typeof socialLinks === 'object' ? socialLinks : {};

    return PLATFORMS.map(({ key, Icon, label, defaultUrl }) => ({
        key,
        Icon,
        label,
        href: normalizeUrl(links[key]) || defaultUrl,
    }));
}
